import { Fragment, useEffect, useState, useCallback, useRef } from 'react'
import { yupResolver } from "@hookform/resolvers/yup"
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from "react-redux"
import { useParams, useNavigate } from 'react-router-dom'
import { isObjEmpty } from '@utils'
import { useForm, Controller } from 'react-hook-form'
import { Row, Col, Button, Label, Input, Form, FormFeedback, Spinner, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap'
import { ArrowLeft, ArrowRight, MessageCircle, Minus, Plus, Settings, Trash2, Check, X } from 'react-feather'
import { DefaultConfig } from '../../../../settings/config'
import { CreateWorkorder, UpdateWorkorder, updateWoData, getVesselByofficialNumber, GetVesslesByAgentId } from '../../../redux/store'
import ComponentSpinner from '../../../../components/spinner/Loading-spinner'
import ToastMessage from '../../../../components/toast-messages'
import Header from '../../../Components/Header'
import MoreActions from '../../../Components/MoreActions'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import 'react-phone-input-2/lib/style.css'
import HeaderMiddleLevel from '../../../Components/HeaderMiddleLevel'

const Vessel = ({ type, category, typeValue, stage, previousStep, nextStep, stageVal, indexValue, openChatModal, setStageData, openCancelText, openCancelModal, instructions, stageName, companyData, isEmployee }) => {
    const sorter = DefaultConfig().sorter
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const selectStyles = DefaultConfig().selectStyles
    const headerText = DefaultConfig().headerText
    const getUserRole = DefaultConfig().getUserRole

    const inputRefs = useRef([])               // refs to DOM inputs
    const prevValueRef = useRef({})            // original value captured on focus
    const enterLockRef = useRef(false)         // prevents double-enter while processing


    const { woId } = useParams()
    const { catCode } = useParams()
    const { typeCode } = useParams()
    const stores = useSelector((state) => state.commonreducerSlice)
    const [nameofAgent, setNameOfAgent] = useState('')
    const [keyContactFirstName, setKeyContactFirstName] = useState('')
    const [keyContactLastName, setKeyContactLastName] = useState('')
    const [primaryEmail, setPrimaryEmail] = useState('')
    const [spinnerStatus, setSpinnerStatus] = useState(true)
    const [spinnerUStatus, setUSpinnerStatus] = useState(true)
    const [woIdData, setwoIdData] = useState(null)
    const [model, setModel] = useState(false)
    const [isDisabled, setDisabled] = useState(false)
    const [agentId, setAgentId] = useState('')
    const [isActive, setIsActive] = useState(false)
    const [vspinnerStatus, setVSpinnerStatus] = useState(false)
    const [isEditFields, setIsEditable] = useState(false)
    const [deleteGroup, setDeleteGroup] = useState([])
    const [displayData, setDisplayData] = useState([])
    const [errorMessage, setErrorMessage] = useState([])
    const [duplicateNumber, setDuplicateNumber] = useState(false)

    const { trigger, handleSubmit, control,
        reset,
        setValue,
        clearErrors,
        getValues,
        formState: { errors } } =
        useForm({ mode: 'onChange', resolver: yupResolver() })

    let newDeleteGroup
    let a = 1
    function UniqueId() {
        a = a + 1
        return `${a}${(new Date()).getTime()}`
    }
    function createArrayUpToNumber() {
        return [...displayData]
    }

    const getNdaData = () => {
        const woIdData = { ...stores?.woIdData?.application }
        if (woIdData && Object.keys(woIdData).length > 0) {
            const vessels = woIdData?.vesselsData
            setNameOfAgent(woIdData?.nameofAgent)
            setAgentId(woIdData?.agentNumber)
            setKeyContactFirstName(woIdData?.keyContactFirstName)
            setKeyContactLastName(woIdData?.keyContactLastName)
            setPrimaryEmail(woIdData?.primaryEmail)
            if (vessels) {
                const AddedIdData = vessels?.map((item) => {
                    return { ...item, id: UniqueId() }
                })
                setDisplayData(AddedIdData)
                setErrorMessage(Array(vessels.length).fill({
                    officialNumber: '',
                    imoNumber: '',
                    nameofShip: '',
                    nameofShipowner: '',
                    ismCompany: '',
                    vesselId: '',
                    ownerIdentificationNumber: ''
                }))
            }
            setwoIdData(woIdData)
        }
    }

    useEffect(() => {
        if (woId) {
            getNdaData()
        }
    }, [])

    useEffect(() => {
        if (!woId) {
            async function f2() {
                setVSpinnerStatus(true)
                const result = JSON.parse(localStorage.getItem("companyData"))
                if (result) {
                    setNameOfAgent(result?.name)
                    setAgentId(result?.value)
                    const response = await dispatch(GetVesslesByAgentId({ AgentNumber: result?.value, ccode: catCode, tcode: typeCode }))
                    const responseData = response.payload
                    setKeyContactFirstName(responseData?.keyContactFirstName)
                    setKeyContactLastName(responseData?.keyContactLastName)
                    setPrimaryEmail(responseData?.primaryEmail)
                    if (response.payload) {
                        const data = response.payload
                        if (data) {
                            const AddedIdData = data?.vesselsData?.map((item) => {
                                return { ...item, id: UniqueId() }
                            })
                            setDisplayData(AddedIdData)
                            setErrorMessage(Array(data?.vesselsData?.length).fill({
                                officialNumber: '',
                                imoNumber: '',
                                nameofShip: "",
                                nameofShipowner: '',
                                ismCompany: '',
                                vesselId: '',
                                ownerIdentificationNumber: ''
                            }))
                        }
                    }
                    setVSpinnerStatus(false)
                }
            }
            f2()
        }
    }, [localStorage.getItem("companyData")])

    const updateYes = async () => {
        const woIdData = { ...stores?.woIdData }
        const application = { ...woIdData?.application }
        application['agentNumber'] = agentId
        application['nameofAgent'] = nameofAgent
        application['keyContactFirstName'] = keyContactFirstName ?? ''
        application['keyContactLastName'] = keyContactLastName ?? ''
        application['primaryEmail'] = primaryEmail ?? ''
        application['vesselsData'] = displayData
        woIdData['application'] = application
        const woIData = { ...stores?.woIData }
        woIData['currentStage'] = stage
        woIData['workorderData'] = woIdData
        setUSpinnerStatus(false)
        await dispatch(UpdateWorkorder({ obj: woIData, ccode: catCode, tcode: typeCode }))
        setUSpinnerStatus(true)
        nextStep(indexValue)
    }

    const areObjectsEqualByKeys = (obj1, obj2, keys) => {
        return keys.every(key => obj1[key] === obj2[key])
    }

    const areArraysEqualByKeys = (array1, array2, keys) => {
        if (array1.length !== array2.length) {
            return false
        }

        const sortedArray1 = array1.slice().sort((a, b) => a.nameofShip.localeCompare(b.nameofShip))
        const sortedArray2 = array2.slice().sort((a, b) => a.nameofShip.localeCompare(b.nameofShip))

        return sortedArray1.every((obj, index) => areObjectsEqualByKeys(obj, sortedArray2[index], keys))
    }

    const validateData = (updatedData) => {
        const newErrorMessage = []
        updatedData.forEach((item) => {
            const error = {}
            if ((item.officialNumber === null) || item.officialNumber === "" || (String(item.officialNumber).length < 4)) {
                if ((item.officialNumber === null) || item.officialNumber === "") {
                    error.officialNumber = "Official number is a required field"
                } else if (String(item.officialNumber).length < 4) {
                    error.officialNumber = "Official number must be 4 digits"
                }
            } else {
                if (item.imoNumber === "") {
                    error.imoNumber = "IMO number is a required field"
                } else if (String(item.imoNumber).length < 7 || String(item.imoNumber).length > 8) {
                    error.imoNumber = "IMO number must be between 7 and 8 digits"
                } else {
                    error.imoNumber = ""
                }
                if (item.nameofShip === "") {
                    error.nameofShip = "Vessel name is a required field"
                } else {
                    error.nameofShip = ""
                }
                if ((item.officialNumber === null) || item.officialNumber === "") {
                    error.officialNumber = "Official number is a required field"
                } else {
                    error.officialNumber = ""
                }
            }
            newErrorMessage.push(error)
        })
        setErrorMessage(newErrorMessage)
        return (newErrorMessage)
    }

    const nextTab = () => {
        const hasActiveVessel = displayData.some(obj => obj.isRemoved !== true)
        if (!hasActiveVessel) {
            toast(t => (<ToastMessage t={t} message={"At least one vessel should be active."} status={"danger"} />))
            return
        }

        if (((woId))) {
            if (stageVal !== 5) {
                const oldVessles = [...stores?.woIdData?.application?.vesselsData]
                const keysToCheck = ["nameofShip", "imoNumber", "officialNumber", "nameofShipowner", "ismCompany", "vesselId", "ownerIdentificationNumber", 'isRemoved']

                const hasMatching = areArraysEqualByKeys(oldVessles, displayData, keysToCheck)
                if (!hasMatching) {
                    const isEmpty = validateData(displayData).every(obj => {
                        return Object.values(obj).every(value => value === "")
                    })
                    if (isEmpty) {
                        updateYes()
                    }
                    setModel(!model)
                } else {
                    nextStep(indexValue)
                }
            } else {
                nextStep(indexValue)
            }
        }

    }

    const saveSubmit = async () => {
        const hasActiveVessel = displayData.some(obj => obj.isRemoved !== true)
        if (!hasActiveVessel) {
            toast(t => (<ToastMessage t={t} message={"At least one vessel should be active."} status={"danger"} />))
            return
        }

        const isEmpty = validateData(displayData).every(obj => {
            return Object.values(obj).every(value => value === "")
        })
        if (isEmpty) {
            setSpinnerStatus(false)
            const object = {}
            object['id'] = woId ? Number(woId) : 0
            object['category'] = category
            object['type'] = typeValue
            object['stage'] = stage
            object['currentStage'] = stage
            const application = {}
            application['agentNumber'] = agentId
            application['nameofAgent'] = nameofAgent
            application['keyContactFirstName'] = keyContactFirstName ?? ''
            application['keyContactLastName'] = keyContactLastName ?? ''
            application['primaryEmail'] = primaryEmail ?? ''
            application['vesselsData'] = displayData
            const WorkorderData = { application }
            object['WorkorderData'] = WorkorderData
            if (woId) {
                const woIData = { ...stores?.woIData }
                const woIdData = { ...stores?.woIdData }
                woIData['stage'] = stage
                woIData['currentStage'] = stage
                woIdData['application'] = application
                woIData['workorderData'] = woIdData
                await dispatch(UpdateWorkorder({ obj: woIData, ccode: catCode, tcode: typeCode }))
                setSpinnerStatus(true)
                setStageData(1)
                nextStep(indexValue)
            } else {
                const responseData = await dispatch(CreateWorkorder({ obj: object, ccode: catCode, tcode: typeCode }))
                const respData = responseData.payload
                setSpinnerStatus(true)
                if (respData) {
                    navigate(`/${catCode}/${typeCode}/${respData.data1.id}`)
                    toast(t => (<ToastMessage t={t} message={"Work Order Created Successfully"} status={"success"} />))
                }
            }

        }
    }

    function Inputvalidation(updatedData, index, attributeName) {
        const newErrorMessage = [...errorMessage]
        const error = {}
        for (let i = 0; i < updatedData.length; i++) {
            if (index === i) {
                if ((updatedData[i][attributeName] === '') || (updatedData[i][attributeName] === null)) {
                    if (attributeName === "imoNumber") {
                        error["imoNumber"] = "IMO Number is a Required Field"
                        error["nameofShip"] = newErrorMessage[index]["nameofShip"]
                        error["nameofShipowner"] = newErrorMessage[index]["nameofShipowner"]
                        error["officialNumber"] = newErrorMessage[index]["officialNumber"]
                    } else if (attributeName === "nameofShip") {
                        error["nameofShip"] = "Vessel Name is a Required Field"
                        error["imoNumber"] = newErrorMessage[index]["imoNumber"]
                        error["nameofShipowner"] = newErrorMessage[index]["nameofShipowner"]
                        error["officialNumber"] = newErrorMessage[index]["officialNumber"]

                    } else if (attributeName === "officialNumber") {
                        error["officialNumber"] = "Official Number is a Required Field"
                        error["imoNumber"] = newErrorMessage[index]["imoNumber"]
                        error["nameofShip"] = newErrorMessage[index]["nameofShip"]
                        error['nameofShipowner'] = newErrorMessage[index]["nameofShipowner"]
                    }
                } else {
                    if (attributeName === "imoNumber") {
                        error["imoNumber"] = ""
                        error["nameofShip"] = newErrorMessage[index]["nameofShip"]
                        error["nameofShipowner"] = newErrorMessage[index]["nameofShipowner"]
                        error["officialNumber"] = newErrorMessage[index]["officialNumber"]
                    } else if (attributeName === "nameofShip") {
                        error["nameofShip"] = ""
                        error["imoNumber"] = newErrorMessage[index]["imoNumber"]
                        error["nameofShipowner"] = newErrorMessage[index]["nameofShipowner"]
                        error["officialNumber"] = newErrorMessage[index]["officialNumber"]
                    } else if (attributeName === "nameofShipowner") {
                        error["nameofShipowner"] = ""
                        error["imoNumber"] = newErrorMessage[index]["imoNumber"]
                        error["nameofShip"] = newErrorMessage[index]["nameofShip"]
                        error['officialNumber'] = newErrorMessage[index]["officialNumber"]
                    } else if (attributeName === "officialNumber") {
                        error["officialNumber"] = ""
                        error["imoNumber"] = newErrorMessage[index]["imoNumber"]
                        error["nameofShip"] = newErrorMessage[index]["nameofShip"]
                        error['nameofShipowner'] = newErrorMessage[index]["nameofShipowner"]
                    }
                }
                if (updatedData[i]["officialNumber"].length > 0 && newErrorMessage[index].officialNumber.length > 0) {
                    if (attributeName === "officialNumber") {
                        error["officialNumber"] = ""
                        error["imoNumber"] = newErrorMessage[index]["imoNumber"]
                        error["nameofShip"] = newErrorMessage[index]["nameofShip"]
                        error['nameofShipowner'] = newErrorMessage[index]["nameofShipowner"]
                    }
                }
                newErrorMessage[index] = error

            }
        }
        setErrorMessage(newErrorMessage)
    }

    const onChangeInput = (e, index, attributeName) => {
        if (e?.target?.value && e?.target?.value?.trim()) {
            const { value } = e.target
            const updatedData = displayData.map((item, i) => {
                if (i === index) {
                    if (attributeName === 'officialNumber' && value.length < 4) {
                        return {
                            ...item,
                            [attributeName]: value,
                            imoNumber: '',
                            nameofShip: '',
                            ismCompany: '',
                            nameofShipowner: '',
                            vesselId: '',
                            ownerIdentificationNumber: ''
                        }
                    } else {
                        return { ...item, [attributeName]: value }
                    }
                }
                return item
            })
            setDisplayData(updatedData)
            Inputvalidation(updatedData, index, attributeName)
        } else {
            const { value } = e.target
            const updatedData = displayData.map((item, i) => {
                if (i === index) {
                    if (attributeName === 'officialNumber' && value.length < 4) {
                        return {
                            ...item,
                            [attributeName]: '',
                            imoNumber: '',
                            nameofShip: '',
                            ismCompany: '',
                            nameofShipowner: '',
                            vesselId: '',
                            ownerIdentificationNumber: ''
                        }
                    } else {
                        return { ...item, [attributeName]: value }
                    }
                }
                return item
            })
            setDisplayData(updatedData)
            Inputvalidation(updatedData, index, attributeName)
        }
    }

    function checkbox(data, findValue) {
        const checkValue = data.find((item) => item.id === findValue.id)
        return checkValue
    }

    const handleImoData = async (value, index) => {
        let duplicate = false
        if (displayData.length > 1) {
            duplicate = displayData.filter(item => item["officialNumber"] === value).length > 1
        }
        setDuplicateNumber(duplicate)
        if (duplicate === true) {
            const newErrorMessage = [...errorMessage]
            const obj = newErrorMessage[index]
            const obj1 = { ...obj, officialNumber: "Duplicate Official Number" }
            newErrorMessage[index] = obj1
            setErrorMessage(newErrorMessage)
        }
        if (duplicate === false) {
            setVSpinnerStatus(true)
            const respDa = await dispatch(getVesselByofficialNumber({ officialNumber: value, ccode: catCode, tcode: typeCode }))
            if (respDa) {
                if (respDa.payload) {
                    const respData = respDa.payload.data
                    if (respData) {
                        if (respData?.errorMessage) {
                            const bufferErrorMessage = [...errorMessage]
                            const obj = bufferErrorMessage[index]
                            const obj1 = { ...obj, officialNumber: respData?.errorMessage }
                            bufferErrorMessage[index] = obj1
                            setErrorMessage(bufferErrorMessage)
                        } else {
                            const dummyData = [...displayData]
                            const obj = { ...dummyData[index] }
                            obj.imoNumber = respData.imoNumber
                            obj.nameofShip = respData.nameofShip
                            obj.ismCompany = respData.ismCompany
                            obj.nameofShipowner = respData.nameofShipowner
                            obj.vesselId = respData.vesselId
                            obj.ownerIdentificationNumber = respData.ownerIdentificationNumber
                            dummyData[index] = { ...obj }
                            setDisplayData(dummyData)
                            const bufferErrorMessage = [...errorMessage]
                            const errobj = bufferErrorMessage[index]
                            const errobj1 = { ...errobj, officialNumber: '', imoNumber: "", nameofShip: "", nameofShipowner: "" }
                            bufferErrorMessage[index] = errobj1
                            setErrorMessage(bufferErrorMessage)
                        }
                    }
                }
                setVSpinnerStatus(false)
            }
        }
    }

    const handleFocus = (e, index) => {
        prevValueRef.current[index] = e.target.value
    }

    const handleBlur = async (e, index) => {
        const newValue = (e.target.value ?? "").trim()
        const oldValue = prevValueRef.current[index] ?? ""

        if (newValue && newValue.length >= 4 && newValue !== oldValue && !enterLockRef.current) {
            enterLockRef.current = true
            try {
                await handleImoData(newValue, index)
                prevValueRef.current[index] = newValue // update baseline after success
            } finally {
                enterLockRef.current = false
            }
        }

    }


    const handleKeyDown = async (e, index) => {
        if (e.key !== "Enter") return

        // stop default (submit/focus change)
        e.preventDefault()

        const el = inputRefs.current[index]
        const newValue = (e.target.value ?? "").trim()
        const oldValue = prevValueRef.current[index] ?? ""

        // basic validation
        if (!newValue || newValue.length < 4) {
            if (el) {
                setTimeout(() => {
                    el.focus()
                    el.setSelectionRange(el.value.length, el.value.length)
                }, 0)
            }
            return
        }

        // if unchanged -> keep focus (do NOT trigger)
        if (newValue === oldValue) {
            if (el) {
                setTimeout(() => {
                    el.focus()
                    el.setSelectionRange(el.value.length, el.value.length)
                }, 0)
            }
            return
        }

        if (enterLockRef.current) return
        enterLockRef.current = true

        try {
            await handleImoData(newValue, index)
            prevValueRef.current[index] = newValue
            // optionally move focus to next input:
            // const next = inputRefs.current[index + 1]
            // if (next) next.focus()
        } finally {
            enterLockRef.current = false
        }
    }

    return (
        <Fragment>
            <div className={vspinnerStatus ? 'from_model_contant' : ''}>{vspinnerStatus ? <ComponentSpinner /> : ''}</div>
            {(woId ? (stores?.wloader && woIdData) : true) ? (
                <dev>
                    <Row>
                        <Col sm='12' md='12' lg='12' xl='12'>
                            <div className='cardpanwlviewwarpperleft1'>
                                <div className='card-box'>
                                    <Row className='mb-2'>
                                        <Col sm='12' md='12' lg='12' xl='12' className='my-1'>
                                            <h5 className='headers-style'>Vessel Information</h5>
                                        </Col>
                                        <Table className={`table table-striped my-50`} responsive>
                                            <thead>
                                                <tr>
                                                    {/* <th style={{ minWidth: '5px' }}>
                                                        <div className=''>
                                                            <Input
                                                                type='checkbox'
                                                                id='Internal'
                                                                disabled={displayData.length === 1} checked={deleteGroup.length === displayData.length && deleteGroup.length !== 0}
                                                                onChange={e => {
                                                                    if (e.target.checked === true) {
                                                                        const newDeleteGroup = createArrayUpToNumber()
                                                                        setDeleteGroup(newDeleteGroup)
                                                                    } else {
                                                                        setDeleteGroup([])
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </th> */}
                                                    <th style={{ minWidth: '5px' }}>S.No</th>
                                                    <th style={{ minWidth: "30px" }}>Official Number</th>
                                                    <th style={{ minWidth: '100px' }}>IMO Number</th>
                                                    <th style={{ minWidth: '250px' }}>Vessel Name</th>
                                                    <th style={{ minWidth: '300px' }}>Vessel Registered Owner</th>
                                                    <th style={{ minWidth: '300px' }}>ISM Company</th>
                                                    <th style={{ minWidth: '30px' }}>Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {displayData.length > 0 && displayData.map((item, index) => (
                                                    <>
                                                        {/* <tr> */}
                                                        <tr key={index}>
                                                            {/* <td style={{ minWidth: '5px' }}>
                                                                <Input
                                                                    type='checkbox'
                                                                    id={`${catCode}_${typeCode}_check_${index}`}
                                                                    style={{ marginLeft: '5px' }}
                                                                    disabled={displayData.length === 1}
                                                                    checked={checkbox(deleteGroup, item)}
                                                                    onChange={e => {
                                                                        newDeleteGroup = [...deleteGroup]
                                                                        if (e.target.checked === true) {
                                                                            newDeleteGroup.push({ ...item })
                                                                            setDeleteGroup(newDeleteGroup)
                                                                        } else {
                                                                            newDeleteGroup = [...deleteGroup]
                                                                            newDeleteGroup = newDeleteGroup.filter(element => (
                                                                                element.id !== item?.id
                                                                            ))
                                                                            setDeleteGroup(newDeleteGroup)
                                                                        }
                                                                    }} />
                                                                <div style={{ color: "red", height: '21px' }}></div>
                                                            </td> */}
                                                            <td style={{ minWidth: '5px' }}>
                                                                {index + 1}
                                                                <div style={{ color: "red" }}></div>
                                                            </td>
                                                            <td style={{ minWidth: "30px" }}>
                                                                <div>
                                                                    <input
                                                                        className='form-control'
                                                                        name="imoNumber"
                                                                        value={item.officialNumber}
                                                                        autoComplete='Off'
                                                                        id={`${catCode}_${typeCode}_officialNumber_${index}`}
                                                                        // disabled={!isEditFields}
                                                                        type="text"
                                                                        onFocus={(e) => handleFocus(e, index)}
                                                                        onChange={(e) => {
                                                                            if (String(e.target.value).length <= 5) {
                                                                                if (!isNaN(e.target.value)) {
                                                                                    onChangeInput(e, index, "officialNumber")
                                                                                }
                                                                            }
                                                                        }}
                                                                        onBlur={(e) => handleBlur(e, index)}
                                                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                                                        disabled={item?.isRemoved}
                                                                        placeholder="Official Number" />
                                                                </div>
                                                                <div style={{ color: "red" }}>
                                                                    {errorMessage[index]?.officialNumber === "" ? "" : errorMessage[index]?.officialNumber}
                                                                </div>
                                                            </td>
                                                            <td style={{ minWidth: '100px' }}>
                                                                <div>
                                                                    <input
                                                                        className='form-control'
                                                                        name="IMO Number"
                                                                        value={item.imoNumber}
                                                                        id={`${catCode}_${typeCode}_imoNumber_${index}`}
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder="IMO Number" />
                                                                </div>
                                                                <div style={{ color: "red" }}>
                                                                    {errorMessage[index]?.imoNumber === "" ? "" : errorMessage[index]?.imoNumber}
                                                                </div>
                                                            </td>
                                                            <td style={{ minWidth: '250px' }}>
                                                                <div>
                                                                    <input
                                                                        className='form-control'
                                                                        name="nameofShip"
                                                                        value={item.nameofShip}
                                                                        id={`${catCode}_${typeCode}_nameofShip_${index}`}
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder="Vessel Name" />
                                                                </div>
                                                                <div style={{ color: "red" }}>
                                                                    {errorMessage[index]?.nameofShip === "" ? "" : errorMessage[index]?.nameofShip}
                                                                </div>
                                                            </td>
                                                            <td style={{ minWidth: '300px' }}>
                                                                <div>
                                                                    <input
                                                                        className='form-control'
                                                                        name="nameofShipowner"
                                                                        value={item.nameofShipowner || ''}
                                                                        id={`${catCode}_${typeCode}_nameofShipowner_${index}`}
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder="Vessel Registered Owner" />
                                                                </div>
                                                                <div style={{ color: "red" }}>
                                                                    {errorMessage[index]?.nameofShipowner === "" ? "" : errorMessage[index]?.nameofShipowner}
                                                                </div>
                                                            </td>
                                                            <td style={{ minWidth: '300px' }}>
                                                                <div>
                                                                    <input
                                                                        className='form-control'
                                                                        name="ismCompany"
                                                                        value={item.ismCompany || ''}
                                                                        id={`${catCode}_${typeCode}_ismCompany_${index}`}
                                                                        type="text"
                                                                        disabled={true}
                                                                        placeholder="ISM Company" />
                                                                </div>
                                                                <div style={{ color: "red" }}>
                                                                    {errorMessage[index]?.ismCompany === "" ? "" : errorMessage[index]?.ismCompany}
                                                                </div>
                                                            </td>
                                                            <td style={{ minWidth: '30px' }}>
                                                                {/* {(displayData.length !== 1) && */}
                                                                <Fragment>
                                                                    <Button
                                                                        className={`btn-next ${isActive ? 'active' : ''} ${item?.isRemoved ? 'd-none' : ''}`}
                                                                        style={{ padding: '10px 16px', backgroundColor: isActive ? 'white' : 'transparent' }}
                                                                        color="danger"
                                                                        size='sm'
                                                                        onClick={() => {
                                                                            setDuplicateNumber(false)
                                                                            const dummyData = [...displayData]
                                                                            const index = dummyData.findIndex(obj => obj.id === item.id)
                                                                            const newErrorMessage = [...errorMessage]

                                                                            if (!dummyData[index]?.isAdded) {
                                                                                dummyData[index].isRemoved = true
                                                                            } else {
                                                                                dummyData.splice(index, 1)
                                                                                newErrorMessage.splice(index, 1)
                                                                            }
                                                                            setDisplayData(dummyData)

                                                                            const newdeleteGroup = [...deleteGroup]
                                                                            const newDeleteGroup1 = newdeleteGroup.filter((obj) => obj.id !== item.id)
                                                                            setDeleteGroup(newDeleteGroup1)
                                                                            setErrorMessage(newErrorMessage)
                                                                            setIsActive(false)
                                                                            if (dummyData.length === 0) {
                                                                                const addingData = []
                                                                                const dummyData = {
                                                                                    id: UniqueId(),
                                                                                    officialNumber: '',
                                                                                    imoNumber: '',
                                                                                    nameofShip: "",
                                                                                    nameofShipowner: '',
                                                                                    ismCompany: '',
                                                                                    isAdded: true,
                                                                                    vesselId: '',
                                                                                    ownerIdentificationNumber: ''
                                                                                }
                                                                                addingData.push(dummyData)
                                                                                const newErrorMessage = []
                                                                                newErrorMessage.push({
                                                                                    officialNumber: '',
                                                                                    imoNumber: '',
                                                                                    nameofShip: "",
                                                                                    ismCompany: "",
                                                                                    nameofShipowner: '',
                                                                                    vesselId: '',
                                                                                    ownerIdentificationNumber: ''
                                                                                })
                                                                                setErrorMessage(newErrorMessage)
                                                                                setDisplayData(addingData)
                                                                            }
                                                                        }}>
                                                                        <Trash2 size={14} />
                                                                        <span className='align-middle d-sm-inline-block mx-50 d-none'>Delete</span>
                                                                    </Button>

                                                                    {/* <Button
                                                                        className={`btn-next ${isActive ? 'active' : ''} ${!item?.isRemoved ? 'd-none' : ''}`}
                                                                        style={{ padding: '10px 16px', backgroundColor: isActive ? 'white' : 'transparent' }}
                                                                        color="danger"
                                                                        size='sm'
                                                                        onClick={() => {
                                                                            setDuplicateNumber(false)
                                                                            const dummyData = [...displayData]
                                                                            const index = dummyData.findIndex(obj => obj.id === item.id)

                                                                            if (dummyData[index]?.vesselId) {
                                                                                dummyData[index].isRemoved = true
                                                                            } else {
                                                                                dummyData.splice(index, 1)
                                                                            }
                                                                            setDisplayData(dummyData)
                                                                            const newErrorMessage = [...errorMessage]
                                                                            newErrorMessage.splice(index, 1)
                                                                            const newdeleteGroup = [...deleteGroup]
                                                                            const newDeleteGroup1 = newdeleteGroup.filter((obj) => obj.id !== item.id)
                                                                            setDeleteGroup(newDeleteGroup1)
                                                                            setErrorMessage(newErrorMessage)
                                                                            setIsActive(false)
                                                                            if (dummyData.length === 0) {
                                                                                const addingData = []
                                                                                const dummyData = {
                                                                                    id: UniqueId(),
                                                                                    officialNumber: '',
                                                                                    imoNumber: '',
                                                                                    nameofShip: "",
                                                                                    nameofShipowner: '',
                                                                                    ismCompany: '',
                                                                                    vesselId: '',
                                                                                    ownerIdentificationNumber: ''
                                                                                }
                                                                                addingData.push(dummyData)
                                                                                const newErrorMessage = []
                                                                                newErrorMessage.push({
                                                                                    officialNumber: '',
                                                                                    imoNumber: '',
                                                                                    nameofShip: "",
                                                                                    ismCompany: "",
                                                                                    nameofShipowner: '',
                                                                                    vesselId: '',
                                                                                    ownerIdentificationNumber: ''
                                                                                })
                                                                                setErrorMessage(newErrorMessage)
                                                                                setDisplayData(addingData)
                                                                            }
                                                                        }}>
                                                                        <Trash2 size={14} />
                                                                        <span className='align-middle d-sm-inline-block mx-50 d-none'>Removed</span>
                                                                    </Button> */}
                                                                    <div>
                                                                        {/* <span className={`btn-next mx-1 ${isActive ? 'active' : ''} ${!item?.isRemoved ? 'd-none' : ''}`} style={{ fontSize: '14px', fontWeight: '600', color: 'red' }}>Removed</span> */}
                                                                        <Button
                                                                            className={`btn-next mx-1 ${isActive ? 'active' : ''} ${!item?.isRemoved ? 'd-none' : ''}`}
                                                                            style={{ padding: '10px 16px', backgroundColor: isActive ? 'white' : 'transparent' }}
                                                                            color="primary"
                                                                            size='sm'
                                                                            onClick={() => {
                                                                                setDuplicateNumber(false)
                                                                                const dummyData = [...displayData]
                                                                                const index = dummyData.findIndex(obj => obj.id === item.id)
                                                                                const newErrorMessage = [...errorMessage]
                                                                                if (!dummyData[index]?.isAdded) {
                                                                                    dummyData[index].isRemoved = false
                                                                                } else {
                                                                                    dummyData.splice(index, 1)
                                                                                    newErrorMessage.splice(index, 1)
                                                                                }
                                                                                setDisplayData(dummyData)
                                                                                const newdeleteGroup = [...deleteGroup]
                                                                                const newDeleteGroup1 = newdeleteGroup.filter((obj) => obj.id !== item.id)
                                                                                setDeleteGroup(newDeleteGroup1)
                                                                                setErrorMessage(newErrorMessage)
                                                                                setIsActive(false)
                                                                                if (dummyData.length === 0) {
                                                                                    const addingData = []
                                                                                    const dummyData = {
                                                                                        id: UniqueId(),
                                                                                        officialNumber: '',
                                                                                        imoNumber: '',
                                                                                        nameofShip: "",
                                                                                        nameofShipowner: '',
                                                                                        ismCompany: '',
                                                                                        isAdded: true,
                                                                                        vesselId: '',
                                                                                        ownerIdentificationNumber: ''
                                                                                    }
                                                                                    addingData.push(dummyData)
                                                                                    const newErrorMessage = []
                                                                                    newErrorMessage.push({
                                                                                        officialNumber: '',
                                                                                        imoNumber: '',
                                                                                        nameofShip: "",
                                                                                        ismCompany: "",
                                                                                        nameofShipowner: '',
                                                                                        vesselId: '',
                                                                                        ownerIdentificationNumber: ''
                                                                                    })
                                                                                    setErrorMessage(newErrorMessage)
                                                                                    setDisplayData(addingData)
                                                                                }
                                                                            }}>
                                                                            <Check size={14} />
                                                                            <span className='align-middle d-sm-inline-block mx-50 d-none'>Active</span>
                                                                        </Button>
                                                                    </div>
                                                                </Fragment>
                                                                {/* } */}
                                                                <div style={{ color: "red" }}></div>
                                                            </td>
                                                        </tr>
                                                    </>
                                                ))
                                                }
                                            </tbody>
                                        </Table>
                                        <Row>
                                            <Col sm='12' md='6' lg='6' xl='6'>
                                                <div className='text__left_qu_btn'>
                                                    {displayData.length !== 1 && <>
                                                        {(deleteGroup.length > 0) &&
                                                            <Button
                                                                className={`btn-next ${isActive ? 'active' : ''}`}
                                                                style={{ backgroundColor: isActive ? 'white' : 'transparent' }}
                                                                color="danger"
                                                                size='sm'
                                                                onClick={() => {
                                                                    setDuplicateNumber(false)
                                                                    const newDeleteGroup = [...deleteGroup]
                                                                    const newData = [...displayData]
                                                                    const indices = newDeleteGroup.map(childObj => {
                                                                        return newData.findIndex(parentObj => {
                                                                            return Object.keys(parentObj).every(key => {
                                                                                return parentObj[key] === childObj[key]
                                                                            })
                                                                        })
                                                                    })
                                                                    const newErrorMessage = [...errorMessage]
                                                                    indices.sort((a, b) => b - a)
                                                                    indices.forEach(index => {
                                                                        if (index < newData.length) {
                                                                            newData.splice(index, 1)
                                                                            newErrorMessage.splice(index, 1)
                                                                        }
                                                                    })
                                                                    setDeleteGroup([])

                                                                    setDisplayData(newData)
                                                                    setErrorMessage(newErrorMessage)
                                                                    if (newData.length === 0) {
                                                                        const addingData = []
                                                                        const dummyData = {
                                                                            id: UniqueId(),
                                                                            officialNumber: '',
                                                                            imoNumber: '',
                                                                            nameofShip: "",
                                                                            ismCompany: "",
                                                                            nameofShipowner: '',
                                                                            vesselId: '',
                                                                            ownerIdentificationNumber: ''
                                                                        }
                                                                        addingData.push(dummyData)
                                                                        const newErrorMessage = []
                                                                        newErrorMessage.push({
                                                                            officialNumber: '',
                                                                            imoNumber: '',
                                                                            nameofShip: "",
                                                                            ismCompany: "",
                                                                            nameofShipowner: '',
                                                                            vesselId: '',
                                                                            ownerIdentificationNumber: ''
                                                                        })
                                                                        setErrorMessage(newErrorMessage)
                                                                        setDisplayData(addingData)
                                                                    }

                                                                }}
                                                            >
                                                                <Trash2 size={14} className='align-middle ms-sm-25 ms-0' />
                                                                <span className='align-middle d-sm-inline-block mx-50 d-none'>Delete</span>
                                                            </Button>
                                                        }
                                                    </>
                                                    }
                                                    {(deleteGroup.length === 0 && displayData.length > 0 && displayData[displayData.length - 1]?.imoNumber !== "") &&
                                                        <Button
                                                            className='btn-next next_btn_panel' size='sm'
                                                            disabled={duplicateNumber}
                                                            color='primary'
                                                            // style={{ display: isEditFields ? 'block' : 'none' }}
                                                            onClick={() => {
                                                                const addingData = [...displayData]
                                                                const dummyData = {
                                                                    id: UniqueId(),
                                                                    officialNumber: '',
                                                                    imoNumber: '',
                                                                    nameofShip: "",
                                                                    ismCompany: "",
                                                                    nameofShipowner: '',
                                                                    vesselId: '',
                                                                    isAdded: true,
                                                                    ownerIdentificationNumber: '',
                                                                    isRemoved: false
                                                                }
                                                                addingData.push(dummyData)
                                                                const newErrorMessage = [...errorMessage]
                                                                newErrorMessage.push({
                                                                    officialNumber: '',
                                                                    imoNumber: '',
                                                                    nameofShip: "",
                                                                    ismCompany: "",
                                                                    nameofShipowner: '',
                                                                    vesselId: '',
                                                                    ownerIdentificationNumber: ''
                                                                })
                                                                setErrorMessage(newErrorMessage)
                                                                setDisplayData(addingData)
                                                                setIsActive(false)
                                                            }}
                                                        >
                                                            <Plus size={14} className='align-middle ms-sm-25 ms-0' />
                                                            <span className='align-middle d-sm-inline-block mx-50 d-none'>Add New</span>
                                                        </Button>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className={headerText ? 'nda_footer_section env_footer' : 'nda_footer_section'}>
                        <Row>
                            <Col md='6' lg='6' xl='6' className='p-0'>
                                <Header firstLevel="Filing Agent" secondLevel="Filing Agent Vessel Amendment Work Order" stageName={stageName} instructions={instructions}></Header>
                            </Col>
                            <Col md='6' lg='6' xl='6' className='p-0'>
                                <HeaderMiddleLevel middleLevel={`${agentId ? `${agentId} - ` : ''}${nameofAgent}`} />
                            </Col>

                        </Row>
                    </div>
                    <div className={headerText ? 'nda_footer_section_btn' : 'nda_footer_section_btn'}>
                        <Col md='12' lg='12' xl='12' className='p-0 step_back'>
                            {(indexValue === 0 && stageVal >= indexValue && stageVal !== 0) ? (
                                <Button color='secondary' className='btn-prev d-none' disabled>
                                    <ArrowLeft size={18} className='align-middle me-sm-25 me-0'></ArrowLeft>
                                    <span className='align-middle d-sm-inline-block d-none'>Back</span>
                                </Button>
                            ) : (
                                <Fragment>
                                    {(indexValue !== 0 && stageVal >= indexValue && stageVal !== 0) ? (
                                        <Button color='secondary' className='btn-prev d-none' onClick={() => previousStep(indexValue)} disabled>
                                            <ArrowLeft size={18} className='align-middle me-sm-25 me-0'></ArrowLeft>
                                            <span className='align-middle d-sm-inline-block d-none'>Back</span>
                                        </Button>
                                    ) : (
                                        <Button color='secondary' className='btn-prev d-none' disabled>
                                            <ArrowLeft size={18} className='align-middle me-sm-25 me-0'></ArrowLeft>
                                            <span className='align-middle d-sm-inline-block d-none'>Back</span>
                                        </Button>
                                    )}
                                </Fragment>
                            )}
                            {woId &&
                                <Button color='info' className='btn-prev' onClick={() => openChatModal()}>
                                    <MessageCircle size={18} className='align-middle me-sm-25 me-0'></MessageCircle>
                                    <span className='align-middle d-sm-inline-block d-none'>Comments</span>
                                </Button>
                            }
                            {woId && isEmployee ? (
                                <MoreActions status={[1]} openCancelModal={openCancelModal} />
                            ) : (
                                woId && !isEmployee && (!stores?.woIdData?.payment?.paymentModeId && stores?.woIdData?.payment?.paymentModeId !== 0) && (
                                    <MoreActions status={[1]} openCancelModal={openCancelModal} />
                                )
                            )}
                            {spinnerStatus ? (
                                <Fragment>
                                    {(stageVal > indexValue) ? (
                                        <Fragment />
                                    ) : (
                                        <Button color='success' className='btn-next' type='submit' onClick={() => saveSubmit()} >
                                            <span className='align-middle d-sm-inline-block d-none'>{woId ? 'Next' : 'Save & Continue'}</span>
                                            <ArrowRight size={18} className='align-middle ms-sm-25 ms-0'></ArrowRight>
                                        </Button>
                                    )}
                                </Fragment>
                            ) : (
                                <Button className='' color='success' type='submit' disabled={!spinnerStatus}>
                                    <Spinner color='primary' size='sm' />
                                    <span className='mx-50'>Loading...</span>
                                </Button>
                            )}
                            {(stageVal > indexValue) ? (
                                <Fragment>
                                    {spinnerUStatus ? (
                                        <Button color='success' className='btn-next' onClick={() => nextTab()} >
                                            <span className='align-middle d-sm-inline-block d-none'>Next</span>
                                            <ArrowRight size={18} className='align-middle ms-sm-25 ms-0'></ArrowRight>
                                        </Button>
                                    ) : (
                                        <Button className='' color='success' type='submit' disabled={!spinnerUStatus}>
                                            <Spinner color='primary' size='sm' />
                                            <span className='mx-50'>Loading...</span>
                                        </Button>
                                    )}
                                </Fragment>
                            ) : (<Fragment />)}
                        </Col>
                    </div>
                </dev>
            ) : (
                <ComponentSpinner />
            )
            }
        </Fragment >
    )
}

export default Vessel
